import { Box, Button, Grid } from '@mui/material'
import SectionHeader from 'components/Common/SectionHeader'
import TypeScriptTable from 'components/Common/Tables/TypeScriptTable/TypeScriptTable'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getClientTaxiRates } from 'reducers/clientsReducer'
import ManageTaxiRates from './ManageTaxiRates'
import getClientTaxiRatesColumns from './TaxiRatesColumns'

type TaxiRatesProps = {
  client: any
}

const pageHeader = 'Mileage Rates'
const pageInfo = 'Mileage rates for vehicle types and locations.'

const TaxiRates = ({ client }: TaxiRatesProps) => {
  const dispatch = useDispatch()
  console.log('Taxi Rates: client triggered: ', client)
  const [addRates, setAddRates] = useState(false)
  const [viewRates, setViewRates] = useState<number | null>(null)
  const [taxiRates, setTaxiRates] = useState<any[]>([])

  const getTaxiRates: Promise<any> = dispatch<any>(
    getClientTaxiRates(client.id),
  ).then((response: any): any => {
    console.log('getTaxiRates triggered with response:', response)
    return response.payload
  })

  const manageTaxiRates = (rateId?: number) => {
    console.log('manageTaxiRates: triggered')
    return (
      <ManageTaxiRates
        client={client}
        rateId={rateId}
        view={!!viewRates}
        closePage={() => {
          setAddRates(false)
          setViewRates(null)
        }}
      />
    )
  }

  useEffect(() => {
    getTaxiRates.then((rates) => {
      console.log('useEffect Triggered: ', rates)
      setTaxiRates(rates.value)
    })
  }, [])

  console.log('clientTaxiRates: ', taxiRates)

  return (
    <Box component={'div'}>
      <Grid container>
        {addRates && (
          <Grid item xs={12}>
            {manageTaxiRates()}
          </Grid>
        )}
        {viewRates && (
          <Grid item xs={12}>
            {manageTaxiRates(viewRates)}
          </Grid>
        )}
        {!addRates && !viewRates && (
          <>
            <Grid item xs={12} sx={{ marginTop: '20px' }}>
              <SectionHeader
                title={`${pageHeader} for ${client.companyName}`}
                subtitle={pageInfo}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setAddRates(true)
                }}
              >
                Add Mileage Rate
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: '20px',
                // display: 'flex',
                // justifyContent: 'center',
              }}
            >
              <Box sx={{ width: '100%' }}>
                <TypeScriptTable
                  data={[...taxiRates].sort((a, b) =>
                    a.areaGroupName.localeCompare(b.areaGroupName),
                  )}
                  columns={getClientTaxiRatesColumns().clientTaxiRatesTableColumns(
                    {
                      onViewRate: (id) => {
                        setViewRates(id)
                      },
                    },
                  )}
                />
              </Box>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  )
}

export default TaxiRates
